import { IconifyIcon } from '@iconify/react';
import { Icon as PhosphorIcon } from '@phosphor-icons/react';

// ----------------------------------------------------------------------

// A Phosphor component (the convention — see src/utils/icons.ts) or, for the
// deliberate exceptions listed there, an Iconify name resolved at runtime.
export type IconifyProps = PhosphorIcon | IconifyIcon | string;

export type { IconWeight } from '@phosphor-icons/react';

// ----------------------------------------------------------------------
// Distinguishes "something <Iconify> can render" from an already-rendered node,
// for the many props typed `IconifyProps | ReactNode`.
//
// Replaces the older `typeof icon === 'string'` checks, which silently stopped
// being exhaustive once registry values became Phosphor components.
export function isIconSpec(value: unknown): value is IconifyProps {
  if (typeof value === 'string') return true;
  if (typeof value !== 'object' || value === null) return false;
  // An IconifyIcon object carries `body`; a Phosphor icon is a forwardRef
  // component, which carries `render` — a React element carries neither.
  return 'body' in value || 'render' in value;
}
